import { summaryAtom } from 'features/generator/contentFormSections/SummaryForm/SummarySection'
import { useAtomValue } from 'jotai'

export const SummarySection = () => {
	const summary = useAtomValue(summaryAtom)

	return summary?.length ? (
		<p className="type-body-caption word-break-fix">{summary}</p>
	) : null
}
